export enum LogType {
    KnowledgeBaseItemVisit = 0,

    AdviceModuleStart = 1,
    AdviceModuleEarlyStop = 2,
    AdviceModuleFinish = 3
}
